import { render, staticRenderFns } from "./applcation_selector.vue?vue&type=template&id=68d8b3c6&%3Akey=selected_application&"
import script from "./applcation_selector.vue?vue&type=script&lang=js&"
export * from "./applcation_selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDialog,VFlex,VRadio,VRadioGroup,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d8b3c6')) {
      api.createRecord('68d8b3c6', component.options)
    } else {
      api.reload('68d8b3c6', component.options)
    }
    module.hot.accept("./applcation_selector.vue?vue&type=template&id=68d8b3c6&%3Akey=selected_application&", function () {
      api.rerender('68d8b3c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application-level/application-selector/applcation_selector.vue"
export default component.exports